import { Component } from '@angular/core';

@Component({
  selector: 'app-check-circle-icon',
  templateUrl: './check-circle-icon.component.html',
  styleUrl: './check-circle-icon.component.scss',
})
export class CheckCircleIconComponent {}
